/**
 * Init edit links, time links, and dropdown action links inside the popover (tippy root).
 * callbacks: { initEditLink(editLink), initTimeLink(timeLink, timeLinkCallbacks), initDropdownActionLink(actionLink), initConfirmManuallyLink(link) }
 */
export function initPopoverContentLinks(callbacks = {}) {
  document.querySelectorAll('[data-tippy-root] .js-showing-view-edit-link').forEach((editLink) => {
    callbacks.initEditLink?.(editLink);
  });
  document.querySelectorAll('[data-tippy-root] .js-showing-view-time-link').forEach((timeLink) => {
    callbacks.initTimeLink?.(timeLink, { toggleTopMode: callbacks.toggleTopMode });
  });
  document.querySelectorAll('[data-tippy-root] .js-showing-actions .js-showing-view-action-link').forEach((actionLink) => {
    callbacks.initDropdownActionLink?.(actionLink);
  });
  document.querySelectorAll('[data-tippy-root] .js-showing-actions .js-confirm-manually-modal').forEach((link) => {
    callbacks.initConfirmManuallyLink?.(link);
  });
}
